<template>
  <div class="row fadein-details">
    <div v-if="!busy && !postSubmit" class="col-12 text-center">
      <h2 class="h3 text-center">
        {{ $t('Lead Declined') }}
      </h2>
      <b-form-group
        :label="$t('Please let us know why you declined this lead')"
        :label-class="'text-center'"
        class="text-left w-75 m-auto py-3"
      >
        <b-form-radio-group v-model="reason" name="decline-reasons" stacked>
          <b-form-radio v-for="(reason, key) in reasons" :key="key" :value="key" @change.prevent="">
            <div class="ml-2 font-weight-bold">
              {{ reason.text }}
            </div>
          </b-form-radio>
        </b-form-radio-group>
        <b-button variant="primary" class="mt-3" size="sm" @click.prevent.stop="submitSurvey">
          {{ $t('Submit') }}
        </b-button>
      </b-form-group>
    </div>
    <div v-else-if="!busy && postSubmit" class="col-12 text-center">
      <h2 class="h3">
        {{ $t('Thank You') }}
      </h2>
      <h3 class="h5">
        {{ $t('We have removed this lead from your list') }}
      </h3>
      <div v-if="postSurveyAction" class="row py-3">
        <div class="text-left w-75 m-auto py-3" v-html="postSurveyAction.text" />
      </div>
      <div class="text-center m-3">
        <b-button variant="primary" size="sm" @click.prevent.stop="$emit('close')">
          {{ $t('Close') }}
        </b-button>
      </div>
    </div>
    <div v-else class="col text-center">
      <spinner />
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import { captureError } from "@/services/userMonitoring";

export default {
  name: "RejectSurvey",
  components: {Spinner},
  props: ['lead'],
  data: function() {
    return {
      busy: true,
      reasons: null,
      reason: null,
      postSubmit: false
    }
  },
  computed: {
    postSurveyAction: function() {
      return this.reasons[this.reason].action
    }
  },
  methods: {
    initSurvey: function() {
      this.$api.leads.rejectReasons()
        .then((response) => {
          this.reasons = response.data.data.options;
          this.busy = false;
        })
        .catch((e) => {
          captureError(e, {
            section: "marketplace",
            action: "get-survey",
            type: "api-request"
          });
          this.busy = false;
        })
    },
    submitSurvey: function() {
      if(this.reason !== null) {
        this.$api.leads.rejectFeedback(this.reason, (this.lead[0] !== undefined) ? this.lead[0].id : this.lead.enquiry.id);
        this.postSubmit = true;
      }
    }
  },
  created: function() {
    this.initSurvey();
  }
}
</script>

<style scoped>

</style>
